import React from 'react';
import { useDispatch } from 'react-redux';
import { openModal } from 'reducers/modalReducer';
import { MODAL_TYPES } from 'view/ModalManager';

/**
 * Renders the View Permit control for a DOB NOW approved permit row.
 *
 * The permit opens in an IMAGE modal, not an iframe. It used to be an iframe
 * because the URL pointed at the DOB NOW portal's printable page, but that
 * never worked for a viewer: the portal serves those pages only to the
 * residential egress and cleared session the scrape holds, so a browser
 * following the link is refused by Akamai.
 *
 * The permit is now photographed during the scrape and stored on our own
 * infrastructure, and the column holds a URL to our image route on the API
 * host. That host refuses to be framed from this origin, so an iframe renders
 * "ecs.violerts.com refused to connect". It is a PNG, so it belongs in an
 * <img>, which ImageModal does.
 */
function WorkPermitPrintLinks(props) {
	const dispatch = useDispatch();
	let { text } = props;
	if (!text) return '-';

	let urls = [];
	if (Array.isArray(text)) {
		urls = text.filter(Boolean);
	} else if (typeof text === 'string') {
		try {
			urls = JSON.parse(text).filter(Boolean);
		} catch (e) {
			if (text.trim()) {
				urls = [text.trim()];
			}
		}
	}

	if (urls.length === 0) {
		return '-';
	}

	const openPermitsModal = (e) => {
		e.preventDefault();
		dispatch(
			openModal(MODAL_TYPES.CONFIRM, {
				title: 'Available Permits',
				noConfirmButton: true,
				closeLabel: 'Close',
				children: (
					<div className="d-flex flex-column py-2">
						<p className="text-muted mb-3">
							This record has {urls.length} work permits available. Click below to download them:
						</p>
						<div className="d-flex flex-column">
							{urls.map((url, idx) => (
								<button
									key={idx}
									onClick={() => {
										dispatch(openModal(MODAL_TYPES.IMAGE, { src: url }));
									}}
									className="btn btn-success d-flex align-items-center justify-content-between p-2 mb-2 w-100 text-white"
									style={{
										textDecoration: 'none',
										color: '#ffffff',
										fontWeight: '500',
										border: 'none'
									}}
								>
									<span style={{ color: '#ffffff' }}>
										<i className="bi bi-file-earmark-pdf me-2 text-white" />
										Work Permit #{idx + 1}
									</span>
									<i className="bi bi-download text-white" />
								</button>
							))}
						</div>
					</div>
				),
			})
		);
	};

	const handleClick = (e) => {
		if (urls.length > 1) {
			openPermitsModal(e);
		} else {
			e.preventDefault();
			dispatch(openModal(MODAL_TYPES.IMAGE, { src: urls[0] }));
		}
	};

	return (
		<a
			href={urls[0]}
			onClick={handleClick}
			className="d-flex justify-content-center align-items-center text-success"
			title={urls.length > 1 ? `Download ${urls.length} Permits` : 'Download Permit'}
			style={{ cursor: 'pointer', fontSize: '1.1rem', textDecoration: 'none' }}
		>
			<i className="bi bi-download" />
		</a>
	);
}

export default WorkPermitPrintLinks;
